
export const PERMISSAO_TAXA = {
  EXCLUIR_LOTE: "taxa_excluir_lote",
  PAGAR_LOTE: "taxa_pagar_lote",
} as const;
